import React, { useEffect, useState } from 'react';
import {
    Container,
    Box,
    Paper,
    Typography,
    FormControl,
    InputLabel,
    Select, AppBar, Toolbar, InputAdornment,
    MenuItem,
    Table,
    TableBody,
    Tooltip,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Checkbox,
    TextField,
    Button,
    Snackbar,
    Alert,
    Grid,
    Card,
    CardContent,
} from '@mui/material';
import { useParams } from "react-router-dom";
import base64 from "base64-js";
import LocationOnIcon from "@mui/icons-material/LocationOn";

function Assignment() {
    const [isMaster, setIsMaster] = useState(false);
const [branches, setBranches] = useState([]);
const [selectedBranchId, setSelectedBranchId] = useState(1);

    const [canAdd, setCanAdd] = useState(false);
    const [canEdit, setCanEdit] = useState(false);
    const [canDelete, setCanDelete] = useState(false);
    const [teacherData, setTeacherData] = useState([]);
    const [classData, setClassData] = useState([]);
    const [sectionData, setSectionData] = useState([]);
    const [subjectData, setSubjectData] = useState([]);
    const [assignmentDropdownData, setAssignmentDropdownData] = useState([]);
    const [selectedTeacher, setSelectedTeacher] = useState('');
    const [selectedClass, setSelectedClass] = useState('');
    const [selectedSection, setSelectedSection] = useState('');
    const [selectedSubject, setSelectedSubject] = useState('');
    const [selectedAssignment, setSelectedAssignment] = useState('');
    const [assignmentData, setAssignmentData] = useState([]);
    const [filteredAssignments, setFilteredAssignments] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [remarks, setRemarks] = useState({});
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [showAllStudents, setShowAllStudents] = useState(false);
    const [showSubmittedOnly, setShowSubmittedOnly] = useState(false);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const decodeFormId = (encodedFormId) => {
        if (!encodedFormId || typeof encodedFormId !== "string") {
            console.error("encodedFormId is missing or invalid:", encodedFormId);
            return null;
        }
        try {
            const paddedEncodedFormId = encodedFormId.padEnd(Math.ceil(encodedFormId.length / 4) * 4, "=");
            const bytes = base64.toByteArray(paddedEncodedFormId);
            return new TextDecoder().decode(bytes);
        } catch (error) {
            console.error("Error decoding formId:", error);
            return null;
        }
    };

    const { encodedFormId } = useParams();
    const formId = decodeFormId(encodedFormId);

    // Pagination logic
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const paginatedAssignments = filteredAssignments.slice(
        (page - 1) * rowsPerPage,
        page * rowsPerPage
    );

    // Reset pagination and selections when filters change
    useEffect(() => {
        setPage(1);
        setSelectedRows([]);
        setFilteredAssignments([]);
        setAssignmentData([]);
    }, [selectedTeacher, selectedClass, selectedSection, selectedSubject, selectedAssignment]);

    const Authorizer = async () => {
        try {
            const apiUrl = process.env.REACT_APP_BASE_URL;
            const token = sessionStorage.getItem("token");
            const response = await fetch(`${apiUrl}/CPanel/Module_Authorizer`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: token,
                },
                body: JSON.stringify({ formId, }), // replace with actual formId if hardcoded
            });

            const result = await response.json();
            const data = result[0];
            // setAuthorization(data);

            setCanEdit(data?.uModify === 1);
            setCanAdd(data?.uWrite === 1);
            setCanDelete(data?.uDelete === 1);
        } catch (error) {
            console.error("Authorization check failed:", error);
        }
    };

    const fetchBranches = async () => {
  try {
    const apiUrl = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem("token");
    const response = await fetch(`${apiUrl}/Branch/GetBranch`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({}),
    });

    if (response.ok) {
      const data = await response.json();
      setBranches(data);
    } else {
      console.error("Failed to fetch branches");
    }
  } catch (error) {
    console.error("Error fetching branches:", error);
  }
};


    const fetchTeacher = async () => {
        try {
            const apiUrl = process.env.REACT_APP_BASE_URL;
            const token = sessionStorage.getItem('token');
            const branchId = isMaster ? selectedBranchId : sessionStorage.getItem("branchId");
            const response = await fetch(`${apiUrl}/CreateClass/ddlTeacher?Branch_Id=${branchId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token,
                },
                body: JSON.stringify({}),
            });
            if (!response.ok) {
                throw new Error(`Error fetching teacher: ${response.status}`);
            }

            const data = await response.json();
            if (data.data === null && data.msg === "Record Not Found") {
                console.error('Record Not Found');
                return; // Exit the function if the record is not found
            }

            setTeacherData(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error(error);
        }
    };

    const fetchClasses = async (teacherId) => {
        try {
            const token = sessionStorage.getItem('token');
            const url = process.env.REACT_APP_BASE_URL;
            const branchId = isMaster ? selectedBranchId : sessionStorage.getItem("branchId");
            const apiUrl = `${url}/AssignmentCreate/GetClass?Branch_Id=${branchId}`;
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token,
                },
                body: JSON.stringify({ teacherId }),
            });
            if (!response.ok) {
                throw new Error(`Error fetching classes: ${response.status}`);
            }
            const data = await response.json();
            if (data.data === null && data.msg === null) {
                console.error('Record Not Found');
                return; // Exit the function if the record is not found
            }
            setClassData(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error(error);
        }
    };

    const fetchSections = async (teacherId, classId) => {
        try {
            const token = sessionStorage.getItem('token');
            const url = process.env.REACT_APP_BASE_URL;
            const branchId = isMaster ? selectedBranchId : sessionStorage.getItem("branchId");
            const apiUrl = `${url}/AssignmentCreate/ddlSection_clsId?Branch_Id=${branchId}`;
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token,
                },
                body: JSON.stringify({ teacherId, classId }),
            });
            if (!response.ok) {
                throw new Error(`Error fetching sections: ${response.status}`);
            }
            const data = await response.json();
            if (data.data === null && data.msg === "Record Not Found") {
                console.error('Record Not Found');
                return; // Exit the function if the record is not found
            }
            setSectionData(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error(error);
        }
    };

    const fetchSubjects = async (classId, sectionId, teacherId) => {
        try {
            const token = sessionStorage.getItem('token');
            const url = process.env.REACT_APP_BASE_URL;
            const branchId = isMaster ? selectedBranchId : sessionStorage.getItem("branchId");
            const apiUrl = `${url}/AssignmentCreate/Subjectddl?Branch_Id=${branchId}`;
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token,
                },
                body: JSON.stringify({ classId, sectionId, teacherId }),
            });
            if (!response.ok) {
                throw new Error(`Error fetching subjects: ${response.status}`);
            }
            const data = await response.json();
            if (Array.isArray(data) && data.length === 0) {
                console.error('No subjects found');
                setSubjectData([]);
                return;
            }
            setSubjectData(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error(error);
            setSubjectData([]);
        }
    };

    const fetchAssignmentDropdown = async (classId, sectionId, subjectId) => {
        try {
            const token = sessionStorage.getItem('token');
            const url = process.env.REACT_APP_BASE_URL;
            const branchId = isMaster ? selectedBranchId : sessionStorage.getItem("branchId");
            const apiUrl = `${url}/AssignmentCreate/GetAssignmentbySubId?Branch_Id=${branchId}`;
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token,
                },
                body: JSON.stringify({ classId, sectionId, subjectId }),
            });
            if (!response.ok) {
                throw new Error(`Error fetching assignments: ${response.status}`);
            }
            const data = await response.json();
            const filteredData = Array.isArray(data) ? data : [];
            if (filteredData.length === 0) {
                console.error('No assignments found');
                setAssignmentDropdownData([]);
                return;
            }
            setAssignmentDropdownData(filteredData);
        } catch (error) {
            console.error(error);
            setAssignmentDropdownData([]);
        }
    };

    const handleTeacherChange = (event) => {
        const selectedTeacherId = event.target.value;
        setSelectedTeacher(selectedTeacherId);
        setSelectedClass('');
        setSelectedSection('');
        setSelectedSubject('');
        setSelectedAssignment('');
        setAssignmentData([]);
        setFilteredAssignments([]);
        setSelectedRows([]);
        setClassData([]);
        setSectionData([]);
        setSubjectData([]);
        setAssignmentDropdownData([]);
        setShowAllStudents(false);
        setShowSubmittedOnly(false);
        fetchClasses(selectedTeacherId);
    };

    const handleClassChange = (event) => {
        const selectedClassId = event.target.value;
        setSelectedClass(selectedClassId);
        setSelectedSection('');
        setSelectedSubject('');
        setSelectedAssignment('');
        setAssignmentData([]);
        setFilteredAssignments([]);
        setSelectedRows([]);
        setSectionData([]);
        setSubjectData([]);
        setAssignmentDropdownData([]);
        setShowAllStudents(false);
        setShowSubmittedOnly(false);
        fetchSections(selectedTeacher, selectedClassId);
    };

    const handleSectionChange = (event) => {
        const selectedSectionId = event.target.value;
        setSelectedSection(selectedSectionId);
        setSelectedSubject('');
        setSelectedAssignment('');
        setAssignmentData([]);
        setFilteredAssignments([]);
        setSelectedRows([]);
        setSubjectData([]);
        setAssignmentDropdownData([]);
        setShowAllStudents(false);
        setShowSubmittedOnly(false);
        fetchSubjects(selectedClass, selectedSectionId, selectedTeacher);
    };

    const handleSubjectChange = (event) => {
        const selectedSubjectId = event.target.value;
        setSelectedSubject(selectedSubjectId);
        setSelectedAssignment('');
        setAssignmentData([]);
        setFilteredAssignments([]);
        setSelectedRows([]);
        setAssignmentDropdownData([]);
        setShowAllStudents(false);
        setShowSubmittedOnly(false);
        fetchAssignmentDropdown(selectedClass, selectedSection, selectedSubjectId);
    };

    const handleAssignmentChange = async (event) => {
        const selectedAssignmentId = event.target.value;
        setSelectedAssignment(selectedAssignmentId);
        
        try {
            const url = process.env.REACT_APP_BASE_URL;
            const apiUrl = `${url}/AssignmentCreate/GetAssignmentView`;
            const token = sessionStorage.getItem('token');
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token,
                },
                body: JSON.stringify({
                    teacherId: selectedTeacher,
                    classId: selectedClass,
                    sectionId: selectedSection,
                    assignmentId: selectedAssignmentId,
                }),
            });
            const data = await response.json();
            setAssignmentData(data);
            setFilteredAssignments(data);
            setShowAllStudents(false);
            setShowSubmittedOnly(false);
        } catch (error) {
            console.error(error);
        }
    };

    // Show all students
    const handleShowAllStudents = () => {
        setShowAllStudents(true);
        setShowSubmittedOnly(false);
        setFilteredAssignments(assignmentData);
        setPage(1);
    };

    // Show submitted only
    const handleShowSubmittedOnly = () => {
        setShowAllStudents(false);
        setShowSubmittedOnly(true);
        const submittedOnly = assignmentData.filter(
            (assignment) => assignment.submitedFile && assignment.submitedFile.trim() !== ""
        );
        setFilteredAssignments(submittedOnly);
        setPage(1);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            // Only select students who have submitted files
            const newSelecteds = paginatedAssignments
                .filter(n => n.submitedFile && n.submitedFile.trim() !== "")
                .map((n) => n.studentId);
            setSelectedRows(newSelecteds);
            return;
        }
        setSelectedRows([]);
    };

    const handleCheckboxClick = (event, studentId) => {
        const selectedIndex = selectedRows.indexOf(studentId);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selectedRows, studentId);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selectedRows.slice(1));
        } else if (selectedIndex === selectedRows.length - 1) {
            newSelected = newSelected.concat(selectedRows.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selectedRows.slice(0, selectedIndex),
                selectedRows.slice(selectedIndex + 1),
            );
        }

        setSelectedRows(newSelected);
    };

    const handleRemarkChange = (event, studentId) => {
        const { value } = event.target;
        setRemarks((prevRemarks) => ({
            ...prevRemarks,
            [studentId]: value,
        }));
    };

    const handleSave = async () => {
        const payload = selectedRows.map((studentId) => ({
            assignmentId: assignmentData.find(row => row.studentId === studentId).assignmentId,
            studentId,
            description: remarks[studentId] || '',
            isStudentChecked: true,
        }));

        try {
            const url = process.env.REACT_APP_BASE_URL;
            const branchId = isMaster ? selectedBranchId : sessionStorage.getItem("branchId");
            const apiUrl = `${url}/AssignmentCreate/SaveAssignmentDescription?Branch_Id=${branchId}`;
            const token = sessionStorage.getItem('token');
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token,
                },
                body: JSON.stringify(payload),
            });
            if (!response.ok) {
                throw new Error(`Error saving assignment: ${response.status}`);
            }
            const result = await response.json();
            console.log('Save result:', result);
            setSnackbarMessage('Data saved successfully!');
            setOpenSnackbar(true);
            setSelectedRows([]);
            setRemarks({});
            setAssignmentData([]);
            setFilteredAssignments([]);
            setSelectedTeacher('');
            setSelectedClass('');
            setSelectedSection('');
            setSelectedSubject('');
            setSelectedAssignment('');
        } catch (error) {
            console.error(error);
            setSnackbarMessage('Error saving data');
            setOpenSnackbar(true);
        }
    };

    const handleCancel = () => {
        setSelectedRows([]);
        setRemarks({});
        setSelectedTeacher('');
        setSelectedClass('');
        setSelectedSection('');
        setSelectedSubject('');
        setSelectedAssignment('');
        setAssignmentData([]);
        setFilteredAssignments([]);
        setShowAllStudents(false);
        setShowSubmittedOnly(false);
    };

    const handleSnackbarClose = () => {
        setOpenSnackbar(false);
    };

    useEffect(() => {
  if (selectedBranchId) {
    fetchTeacher();
   handleCancel();
  }
}, [selectedBranchId]);

    useEffect(() => {
        fetchTeacher();
        Authorizer();
    }, []);

    useEffect(() => {
  const isMasterUser = sessionStorage.getItem("is_Master") === "true";
  setIsMaster(isMasterUser);

  if (isMasterUser) {
    fetchBranches();
  } else {
    const branchId = sessionStorage.getItem("branchId");
    setSelectedBranchId(branchId);
  }
}, []);


    return (
        <Box sx={{ p: 3, backgroundColor: '#f5f7fa', minHeight: '100vh' }}>
            <Snackbar
                open={openSnackbar}
                autoHideDuration={3000}
                onClose={handleSnackbarClose}
                message={snackbarMessage}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                sx={{
                    '& .MuiSnackbarContent-root': {
                        backgroundColor: snackbarMessage.includes('Error') ? '#d32f2f' : '#4caf50',
                        color: '#fff',
                        fontWeight: 'bold',
                    },
                }}
            />

  <AppBar
  position="static"
  sx={{
    backgroundColor: "#0B1F3D",
    boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
    mb:1
  }}
>
  <Toolbar sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", px: 3 }}>
    
    {/* Left: Title */}
    <Typography
      variant="h4"
      sx={{
        fontWeight: 700,
        letterSpacing: "0.5px",
        color: "#ffffff",
      }}
    >
     Assignments
    </Typography>

    {/* Right: Branch Dropdown */}
   {isMaster && (
  <Box sx={{ position: "relative" }}>
    <FormControl size="small" sx={{ width: 220 }}>
      <InputLabel
        sx={{
          color: "rgba(255,255,255,0.6)",
          fontSize: "0.75rem",
          fontWeight: 500,
          letterSpacing: "0.6px",
          textTransform: "uppercase",
          top: "-2px",
          "&.Mui-focused": { color: "#64B5F6" },
          "&.MuiFormLabel-filled": { color: "rgba(255,255,255,0.7)" },
        }}
      >
        Branch
      </InputLabel>
      <Select
        value={selectedBranchId || ""}
        onChange={(e) => setSelectedBranchId(e.target.value)}
        label="Branch"
        startAdornment={
          <InputAdornment position="start">
            <LocationOnIcon sx={{ fontSize: 16, color: "rgba(255,255,255,0.5)", ml: 0.5 }} />
          </InputAdornment>
        }
        sx={{
          color: "#ffffff",
          fontWeight: 500,
          fontSize: "0.875rem",
          letterSpacing: "0.3px",
          backgroundColor: "rgba(255,255,255,0.07)",
          backdropFilter: "blur(8px)",
          borderRadius: "8px",
          transition: "background-color 0.2s ease, box-shadow 0.2s ease",

          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(255,255,255,0.15)",
            borderWidth: "1px",
            transition: "border-color 0.2s ease",
          },
          "&:hover": {
            backgroundColor: "rgba(255,255,255,0.11)",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "rgba(255,255,255,0.35)",
            },
          },
          "&.Mui-focused": {
            backgroundColor: "rgba(255,255,255,0.1)",
            boxShadow: "0 0 0 3px rgba(100,181,246,0.18)",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#64B5F6",
              borderWidth: "1.5px",
            },
          },
          "& .MuiSelect-icon": {
            color: "rgba(255,255,255,0.5)",
            transition: "color 0.2s ease",
          },
          "&.Mui-focused .MuiSelect-icon": {
            color: "#64B5F6",
          },
          "& .MuiSelect-select": {
            py: 1.1,
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              mt: 0.5,
              borderRadius: "10px",
              border: "1px solid rgba(11,31,61,0.12)",
              boxShadow: "0 8px 32px rgba(11,31,61,0.18), 0 2px 8px rgba(0,0,0,0.08)",
              overflow: "hidden",
              "& .MuiList-root": { py: 0.5 },
            },
          },
        }}
      >
        {branches.map((branch) => (
          <MenuItem
            key={branch.branchId}
            value={branch.branchId}
            sx={{
              fontSize: "0.875rem",
              fontWeight: 500,
              color: "#0B1F3D",
              px: 2,
              py: 1.1,
              mx: 0.5,
              borderRadius: "6px",
              transition: "background-color 0.15s ease",
              "&:hover": {
                backgroundColor: "rgba(11,31,61,0.07)",
              },
              "&.Mui-selected": {
                backgroundColor: "rgba(25,118,210,0.1)",
                color: "#1565C0",
                fontWeight: 600,
                "&:hover": {
                  backgroundColor: "rgba(25,118,210,0.15)",
                },
              },
            }}  
          >
            {branch.branchName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Box>
)}
  </Toolbar>
</AppBar>
            <Card sx={{ mb: 3, boxShadow: 3, borderRadius: 2 }}>
                <CardContent>
                    {/* <Typography variant="h4" sx={{ mb: 3, fontWeight: 'bold', color: '#1976d2' }}>
                        Assignment
                    </Typography> */}

                 

                    <Grid container spacing={2} sx={{ mb: 3 }}>
                        <Grid item xs={12} md={2.4}>
                            <FormControl fullWidth variant="outlined">
                                <InputLabel>Select Teacher</InputLabel>
                                <Select
                                    value={selectedTeacher}
                                    onChange={handleTeacherChange}
                                    label="Select Teacher"
                                    sx={{ backgroundColor: 'white' }}
                                >
                                    <MenuItem value="">Select Teacher</MenuItem>
                                    {teacherData.map((teacher) => (
                                        <MenuItem key={teacher.employeeId} value={teacher.employeeId}>
                                            {teacher.employeeName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} md={2.4}>
                            <FormControl fullWidth variant="outlined" disabled={!selectedTeacher}>
                                <InputLabel>Select Class</InputLabel>
                                <Select
                                    value={selectedClass}
                                    onChange={handleClassChange}
                                    label="Select Class"
                                    sx={{ backgroundColor: 'white' }}
                                >
                                    <MenuItem value="">Select Class</MenuItem>
                                    {classData.map((cls) => (
                                        <MenuItem key={cls.classId} value={cls.classId}>
                                            {cls.className}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} md={2.4}>
                            <FormControl fullWidth variant="outlined" disabled={!selectedClass}>
                                <InputLabel>Select Section</InputLabel>
                                <Select
                                    value={selectedSection}
                                    onChange={handleSectionChange}
                                    label="Select Section"
                                    sx={{ backgroundColor: 'white' }}
                                >
                                    <MenuItem value="">Select Section</MenuItem>
                                    {sectionData.map((sec) => (
                                        <MenuItem key={sec.sectionId} value={sec.sectionId}>
                                            {sec.sectionName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} md={2.4}>
                            <FormControl fullWidth variant="outlined" disabled={!selectedSection}>
                                <InputLabel>Select Subject</InputLabel>
                                <Select
                                    value={selectedSubject}
                                    onChange={handleSubjectChange}
                                    label="Select Subject"
                                    sx={{ backgroundColor: 'white' }}
                                >
                                    <MenuItem value="">Select Subject</MenuItem>
                                    {subjectData.map((sub) => (
                                        <MenuItem key={sub.subjectId} value={sub.subjectId}>
                                            {sub.subjectName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} md={2.4}>
                            <FormControl fullWidth variant="outlined" disabled={!selectedSubject}>
                                <InputLabel>Select Assignment</InputLabel>
                                <Select
                                    value={selectedAssignment}
                                    onChange={handleAssignmentChange}
                                    label="Select Assignment"
                                    sx={{ backgroundColor: 'white' }}
                                >
                                    <MenuItem value="">Select Assignment</MenuItem>
                                    {assignmentDropdownData.map((assignment) => (
                                        <MenuItem key={assignment.assignmentId} value={assignment.assignmentId}>
                                            {assignment.assignmentName || assignment.assignmentDescription}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>

                    {assignmentData.length > 0 && (
                        <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
                            <Button
                                variant="contained"
                                onClick={handleShowAllStudents}
                                sx={{
                                    backgroundColor: '#0fb4a1',
                                    '&:hover': { backgroundColor: '#0b8c7f' },
                                }}
                            >
                                Show All Students
                            </Button>
                            <Button
                                variant="contained"
                                onClick={handleShowSubmittedOnly}
                                sx={{
                                    backgroundColor: '#0fac99',
                                    '&:hover': { backgroundColor: '#0b8c7f' },
                                }}
                            >
                                Show Submitted Only
                            </Button>
                        </Box>
                    )}
                </CardContent>
            </Card>

            {filteredAssignments.length > 0 && (
                <Card sx={{ boxShadow: 3, borderRadius: 2 }}>
                    <CardContent>
                        <TableContainer component={Paper} sx={{ boxShadow: 'none' }}>
                            <Table>
                                <TableHead sx={{ backgroundColor: '#1976d2 !important' }}>
                                    <TableRow>
                                        <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>
                                            <Checkbox
                                                indeterminate={selectedRows.length > 0 && selectedRows.length < paginatedAssignments.filter(n => n.submitedFile && n.submitedFile.trim() !== "").length}
                                                checked={paginatedAssignments.filter(n => n.submitedFile && n.submitedFile.trim() !== "").length > 0 && selectedRows.length === paginatedAssignments.filter(n => n.submitedFile && n.submitedFile.trim() !== "").length}
                                                onChange={handleSelectAllClick}
                                                sx={{ color: 'white' }}
                                            />
                                        </TableCell>
                                        <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Admission No</TableCell>
                                        <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Student Name</TableCell>
                                        <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Roll No</TableCell>
                                        {/* <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Subject Name</TableCell> */}
                                        <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Submitted File</TableCell>
                                        <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Remarks</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {paginatedAssignments.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={7} align="center">
                                                <Typography sx={{ py: 3, color: '#666' }}>No Data Available</Typography>
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        paginatedAssignments.map((row) => (
                                            <TableRow
                                                key={row.studentId}
                                                selected={selectedRows.indexOf(row.studentId) !== -1}
                                                hover
                                            >
                                                <TableCell>
                                                    <Checkbox
                                                        checked={selectedRows.indexOf(row.studentId) !== -1}
                                                        onChange={(event) => handleCheckboxClick(event, row.studentId)}
                                                        color="primary"
                                                        disabled={!row.submitedFile || row.submitedFile.trim() === ""}
                                                    />
                                                </TableCell>
                                                <TableCell>{row.admissionNo}</TableCell>
                                                <TableCell>{row.studentName}</TableCell>
                                                <TableCell>{row.rollNo}</TableCell>
                                                {/* <TableCell>{row.subjectName}</TableCell> */}
                                                <TableCell>
                                                    {row.submitedFile && row.submitedFile.trim() !== "" ? (
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            size="small"
                                                            href={`https://wsmsv1.aidigitalsec.com/${row.submitedFile}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            View File
                                                        </Button>
                                                    ) : (
                                                        <Button variant="outlined" size="small" disabled>
                                                            NOT SUBMITTED
                                                        </Button>
                                                    )}
                                                </TableCell>
                                                <TableCell>
                                                    <TextField
                                                        variant="outlined"
                                                        size="small"
                                                        value={remarks[row.studentId] || ''}
                                                        onChange={(event) => handleRemarkChange(event, row.studentId)}
                                                        disabled={!row.submitedFile || row.submitedFile.trim() === ""}
                                                        fullWidth
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <Box sx={{ 
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            alignItems: 'center',
                            mt: 3,
                            pt: 2,
                            borderTop: '1px solid #e0e0e0'
                        }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Typography variant="body2" sx={{ color: '#666' }}>
                                    Rows per page
                                </Typography>
                                <FormControl size="small" sx={{ minWidth: 80 }}>
                                    <Select
                                        value={rowsPerPage}
                                        onChange={(e) => {
                                            setRowsPerPage(e.target.value);
                                            setPage(1);
                                        }}
                                        sx={{ backgroundColor: 'white' }}
                                    >
                                        <MenuItem value={5}>5</MenuItem>
                                        <MenuItem value={10}>10</MenuItem>
                                        <MenuItem value={25}>25</MenuItem>
                                        <MenuItem value={50}>50</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>
                            
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                <Typography variant="body2" sx={{ color: '#666' }}>
                                    Page {page} of {Math.ceil(filteredAssignments.length / rowsPerPage) || 1}
                                </Typography>
                                
                                <Box sx={{ display: 'flex', gap: 1 }}>
                                    <Button
                                        variant="outlined"
                                        onClick={() => setPage(page - 1)}
                                        disabled={page === 1}
                                        sx={{ 
                                            minWidth: '80px',
                                            color: '#666',
                                            borderColor: '#ddd',
                                            '&:hover': { borderColor: '#999' }
                                        }}
                                    >
                                        PREV
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        onClick={() => setPage(page + 1)}
                                        disabled={page >= Math.ceil(filteredAssignments.length / rowsPerPage)}
                                        sx={{ 
                                            minWidth: '80px',
                                            color: '#1976d2',
                                            borderColor: '#1976d2',
                                            '&:hover': { backgroundColor: '#f0f7ff' }
                                        }}
                                    >
                                        NEXT
                                    </Button>
                                </Box>
                            </Box>
                        </Box>
                    </CardContent>
                </Card>
            )}

            {filteredAssignments.length > 0 && (
                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 3 }}>
                    <Tooltip title={!canAdd && "You are not Authorized to make Changes"} arrow>
                        <span>
                            <Button
                                variant="contained"
                                onClick={handleSave}
                                disabled={!canAdd}
                                sx={{ 
                                    backgroundColor: '#4caf50', 
                                    '&:hover': { backgroundColor: '#388e3c' },
                                    minWidth: '100px'
                                }}
                            >
                                SAVE
                            </Button>
                        </span>
                    </Tooltip>
                    <Button
                        variant="contained"
                        onClick={handleCancel}
                        sx={{ 
                            backgroundColor: '#f44336', 
                            '&:hover': { backgroundColor: '#d32f2f' },
                            minWidth: '100px'
                        }}
                    >
                        RESET
                    </Button>
                </Box>
            )}
        </Box>
    );
}

export default Assignment;